import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import PunchoutValidation from "./PunchoutValidation";
import { api } from "store/slices/api";

const PublishToPunchoutModal = ({ quoteId }) => {
  const [showModal, setShowModal] = useState(false);
  const { data = {} } = api.useGetPriceQuoteQuery(quoteId);
  const isPublished = data.punchoutPublished === true;

  return (
    <>
      <div className="d-flex align-items-center me-2">
        {(isPublished || data.punchoutPublished === false) && (
          <Badge bg={isPublished ? "success" : "danger"} text="light">
            {isPublished ? "Published" : "Unpublished"}
          </Badge>
        )}
      </div>
      <Button variant="outline-primary" onClick={() => setShowModal(true)}>
        {isPublished ? "Unpublish" : "Add to PunchOut"}
      </Button>

      {showModal && (
        <PunchoutValidation quoteId={quoteId} isPublished={isPublished} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};
export default PublishToPunchoutModal;
